export default "__VITE_ASSET__CeiOfqio__"